import { useDocumentsRepository } from '@Hooks/useRepository';
import type { ApiPrintOption, ApiPrintOptionPayload } from '@Model';
import { PrintOptionsRepository } from '@Repositories/Documents';
import { isNullOrEmpty, isKey } from '@synqo/frontend-component-library';
import { type QueryKey, useQuery } from '@tanstack/react-query';

export function useGetPrintOption(printOptionId: string, payload?: ApiPrintOptionPayload): ApiPrintOption | undefined {
    const printOptions = useDocumentsRepository(PrintOptionsRepository);

    const hasPayload = payload !== undefined;
    const hasPayloadKey = hasPayload && isKey(payload?.primary_id);
    const enabled = !isNullOrEmpty(printOptionId) && (!hasPayload || hasPayloadKey);
    const queryKey: QueryKey = ['documents', 'print_options', printOptionId];

    const { data: queryResult } = useQuery({
        queryFn: () =>
            payload === undefined
                ? printOptions.getPrintOptionGet(printOptionId)
                : printOptions.getPrintOptionPost(printOptionId, payload),
        queryKey: queryKey,
        enabled: enabled,
    });

    return enabled ? queryResult?.data : undefined;
}
